import { req } from '../utils/request'

export class Dict {
  getOptions(params) {
    return req.post('user.dict/getOptions', params)
  }
}

export default new Dict()
